import { render, staticRenderFns } from "./DataSideNavItems.vue?vue&type=template&id=301f9508"
import script from "./DataSideNavItems.vue?vue&type=script&lang=ts"
export * from "./DataSideNavItems.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports